import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { trash_01 } from "@tql/ui-components-react/untitled/icons";
import { memo, useCallback } from "react";

import type { Invoice } from "~/shared/schemas/invoice-schema";

type DeleteCellProps = GridCustomCellProps & {
	onDelete: (invoiceId: string) => void;
};

export const DeleteCell = memo(function DeleteCell({
	dataItem,
	onDelete,
	...tdProps
}: DeleteCellProps) {
	const invoice = dataItem as Invoice;

	const handleDelete = useCallback(() => {
		onDelete(invoice.invoiceID.toString());
	}, [invoice.invoiceID, onDelete]);
	return (
		<td
			{...tdProps.tdProps}
			style={{
				...tdProps.tdProps?.style,
				verticalAlign: "middle",
				textAlign: "center",
			}}
		>
			<button
				onClick={handleDelete}
				style={{
					background: "none",
					border: "none",
					cursor: "pointer",
					padding: 0,
				}}
				type={"button"}
			>
				<SvgIcon
					icon={trash_01}
					size={"xxlarge"}
					style={{ color: "var(--kendo-color-error-on-surface)" }}
				/>
			</button>
		</td>
	);
});

DeleteCell.displayName = "DeleteCell";
